// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// Uom — source: shared/config/uom.config.json

export const UOM_VALUES = ["unit", "each", "dozen", "pair", "set", "can", "jar", "bottle", "pouch", "sachet", "carton", "package", "bag", "drum", "bale", "bundle", "roll", "pallet", "kg", "g", "mt", "lb", "l", "m3", "m", "m2"] as const;
export type Uom = (typeof UOM_VALUES)[number];

export const uomDimension: Record<Uom, "count" | "mass" | "volume" | "length" | "area"> = {
  "unit": "count",
  "each": "count",
  "dozen": "count",
  "pair": "count",
  "set": "count",
  "can": "count",
  "jar": "count",
  "bottle": "count",
  "pouch": "count",
  "sachet": "count",
  "carton": "count",
  "package": "count",
  "bag": "count",
  "drum": "count",
  "bale": "count",
  "bundle": "count",
  "roll": "count",
  "pallet": "count",
  "kg": "mass",
  "g": "mass",
  "mt": "mass",
  "lb": "mass",
  "l": "volume",
  "m3": "volume",
  "m": "length",
  "m2": "area",
};

export const uomCountsPackages: Record<Uom, false | true> = {
  "unit": false,
  "each": false,
  "dozen": false,
  "pair": false,
  "set": false,
  "can": false,
  "jar": false,
  "bottle": false,
  "pouch": false,
  "sachet": false,
  "carton": true,
  "package": true,
  "bag": true,
  "drum": true,
  "bale": true,
  "bundle": true,
  "roll": true,
  "pallet": true,
  "kg": false,
  "g": false,
  "mt": false,
  "lb": false,
  "l": false,
  "m3": false,
  "m": false,
  "m2": false,
};

export const uomDecimalPlaces: Record<Uom, 6 | 0> = {
  "unit": 6,
  "each": 0,
  "dozen": 0,
  "pair": 0,
  "set": 0,
  "can": 0,
  "jar": 0,
  "bottle": 0,
  "pouch": 0,
  "sachet": 0,
  "carton": 0,
  "package": 0,
  "bag": 0,
  "drum": 0,
  "bale": 0,
  "bundle": 0,
  "roll": 0,
  "pallet": 0,
  "kg": 6,
  "g": 6,
  "mt": 6,
  "lb": 6,
  "l": 6,
  "m3": 6,
  "m": 6,
  "m2": 6,
};

export const uomUneceCode: Record<Uom, "C62" | "EA" | "DZN" | "PR" | "SET" | "CA" | "JR" | "BO" | "CT" | "PK" | "BG" | "DR" | "BL" | "BE" | "RO" | "PF" | "KGM" | "GRM" | "TNE" | "LBR" | "LTR" | "MTQ" | "MTR" | "MTK"> = {
  "unit": "C62",
  "each": "EA",
  "dozen": "DZN",
  "pair": "PR",
  "set": "SET",
  "can": "CA",
  "jar": "JR",
  "bottle": "BO",
  "pouch": "C62",
  "sachet": "C62",
  "carton": "CT",
  "package": "PK",
  "bag": "BG",
  "drum": "DR",
  "bale": "BL",
  "bundle": "BE",
  "roll": "RO",
  "pallet": "PF",
  "kg": "KGM",
  "g": "GRM",
  "mt": "TNE",
  "lb": "LBR",
  "l": "LTR",
  "m3": "MTQ",
  "m": "MTR",
  "m2": "MTK",
};

